$(document).ready(function() {
    $('#ShowCalendar li').click(function() {
        $(this).find(".more_info_pannel").slideToggle();
    });
    CloudZoom.quickStart();
});


$(function() {
    // $('#SideShowMake').cycle();
  $("a.galleryPreview").fancybox({
        'transitionIn'  :   'elastic',
        'transitionOut' :   'elastic',
        'speedIn'       :   600,
        'speedOut'      :   200,
        'overlayShow'   :   false
    });
});


$(window).bind("load", function() {
   $('#SideShowMake').cycle();
});


